import { render, staticRenderFns } from "./BaseStateInit.vue?vue&type=template&id=c28588d0"
import script from "./BaseStateInit.vue?vue&type=script&lang=js"
export * from "./BaseStateInit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports